import { render, staticRenderFns } from "./AcountIcon.vue?vue&type=template&id=557bc3d1&scoped=true"
import script from "./AcountIcon.vue?vue&type=script&lang=ts"
export * from "./AcountIcon.vue?vue&type=script&lang=ts"
import style0 from "./AcountIcon.vue?vue&type=style&index=0&id=557bc3d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557bc3d1",
  null
  
)

export default component.exports